import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "count"]
  static values = {
    max: { type: Number, default: 500 }
  }

  connect() {
    this.update()
  }

  update() {
    const length = this.inputTarget.value.length
    const remaining = this.maxValue - length

    this.countTarget.textContent = `${length}/${this.maxValue}`

    this.countTarget.classList.toggle("text-error", remaining < 0)
    this.countTarget.classList.toggle("text-warning", remaining >= 0 && remaining < 20)
  }
}
